<template lang="html">
  <b-container id="view-Users" fluid>
    <div>
      <b-row>
        <b-col>
          <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
            <h5 v-translate>Profile was updated!</h5>
          </b-alert>
          <b-card class="user-info">
            <b-alert variant="warning" v-if="user.disabled_reason !== null" show>
              <h4>{{user.disabled_reason.description}}</h4>
            </b-alert>
            <b-row>
              <b-col cols="8">
                <h1>{{user.name}}
                  <b-button variant="danger" size="sm" v-show="user.active" v-b-modal.modalDisableReason :disabled="userIsSuperAdmin" v-translate>Disable User</b-button>
                  <b-button variant="success" size="sm" v-show="!user.active && user.enablable" @click="enableUser" v-translate>Enable User</b-button>
                </h1>
                <b-modal id="modalDisableReason" ref="modalDisableReason" hide-footer @hide="disableReasonId = null">
                  <div slot="modal-title" v-translate>Disable User Reason</div>
                  <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
                  <form @submit.stop.prevent="disableUser">
                    <b-form-radio-group stacked v-model="disableReasonId" :options="disableReasons.map(x => { return {value: x.id, text: (!x.reversible ? $gettext('***NOT REVERSIBLE***') : '') + x.description}})" required />
                    <b-form-row>
                      <div class="text-center form-group col-12 form-actions">
                        <b-button type="submit" variant="danger" :disabled="!disableReasonId" size="lg" v-translate>Disable User</b-button>
                        <b-button type="button" @click.prevent="$refs.modalDisableReason.hide()" variant="outline-secondary" size="lg" v-translate>Cancel</b-button>
                      </div>
                    </b-form-row>
                  </form>
                </b-modal>
                <div class="mobile-apps" v-if="userMobileApps.length > 0">
                  <p>
                    <translate>Currently using</translate>
                    <b-badge v-for="(app, index) in userMobileApps" :key="index">{{app.name}} ({{app.version}})</b-badge></p>
                </div>
                <p v-translate="{data: moment(user.created_at).format('L LT')}">User since %{data}</p>
                <div class="form-group col-12 mt-3">
                  <b-form-checkbox size="lg" v-model="user.second_factor_enabled" :value="1" :unchecked-value="0" switch>
                    <translate>Enable Two-Factor Authentication (2FA)</translate>
                  </b-form-checkbox>
                </div>
              </b-col>
              <b-col class="text-center">
                <div v-show="user.profile_picture">
                  <b-img v-if="user.profile_picture" rounded="rounded" :src="user.profile_picture" width="100" height="100" blank-color="#777" alt="img" class="m-1" /><br>
                  <b-button pill size="sm" v-b-modal.modalUploadImage>
                    <translate>Change</translate>
                  </b-button>
                  <b-button pill size="sm" variant="danger" @click.stop="deleteProfileImage" style="padding: .5rem .65rem">
                    <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
                  </b-button>
                </div>
                <div v-show="!user.profile_picture">
                  <b-img v-if="!user.profile_picture" rounded="circle" src="https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm" width="100" height="100" blank-color="#777" alt="img" class="m-1" />
                  <b-button size="sm" v-b-modal.modalUploadImage v-translate>Add Photo</b-button>
                </div>
              </b-col>
            </b-row>
            <div class="mb-3">
              <b-button size="sm" v-b-modal.modalFixedPrice v-if="isHeadOperations" v-translate>Set Fixed Price Time Slot for User</b-button>
              <b-modal id="modalFixedPrice" ref="modalFixedPrice" :title="$gettext('Set Fixed Price Time Slot for User')" hide-footer>
                <fixed-price-form :user="user" @success="fixedPriceSuccess" @cancel="fixedPriceCancel" />
              </b-modal>

              <pending-fixed-prices :pending-fixed-prices="pendingFixedPrices" />
            </div>

            <b-row>
              <b-col>
                <h2>
                  <translate>Personal Info</translate>
                  <b-button v-b-modal.modalChangePassword v-if="((isSuperAdmin || isAdmin) && !userIsSuperAdmin) || user.id === $store.getters.profile.id">
                    <translate>Change Password</translate>
                  </b-button>
                </h2>
                <b-form @submit.prevent="updateStatus(shipping.id)">
                  <b-form-row>
                    <div class="form-group col-lg-6">
                      <label for="change-status" v-translate>Name</label>
                      <div class="input-group">
                        <b-form-input v-model="user.name" type="text" />
                      </div>
                    </div>
                    <div class="form-group col-lg-6">
                      <label for="change-status" v-translate>User Status</label>
                      <div class="input-group">
                        <b-form-select v-model="user.status" :options="userStatuses" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group col-lg-6">
                      <label for="change-status" v-translate>Email</label>
                      <div class="input-group">
                        <b-form-input v-model="user.email" type="text" :disabled="!isSuperAdmin && !isAdmin" />
                      </div>
                    </div>
                    <b-form-group class="col-lg-6" v-if="accountingCatalogs.filter(x => x.catalog === 'tax_conditions').length > 0" :label="$gettext('Contributor Type')" label-for="user-contributor-type">
                      <b-form-select id="user-contributor-type" v-model="user.contributor_type" :options="accountingCatalogs.filter(x => x.catalog === 'tax_conditions').map(x => { return {text: x.name, value: x.id}})" class="form-control">
                        <template #first>
                          <option :value="null" v-translate>Contributor Type</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group class="col-lg-6" v-if="accountingCatalogs.filter(x => x.catalog === 'document_types').length > 0" :label="$gettext('Document Type')" label-for="user-tin-type">
                      <b-form-select id="user-tin-type" v-model="user.tin_type" :options="accountingCatalogs.filter(x => x.catalog === 'document_types').map(x => { return {text: x.name, value: x.id}})" class="form-control">
                        <template #first>
                          <option :value="null" v-translate>Document Type</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                    <div class="form-group col-lg-6">
                      <label for="change-status" v-translate>TIN</label>
                      <div class="input-group">
                        <b-form-input v-model="user.tin" type="text" :disabled="hasTin && !(isSuperAdmin || isAdmin || isAccountant)" />
                      </div>
                    </div>
                    <b-form-group class="col-lg-6" v-if="accountingCatalogs.filter(x => x.catalog === 'payment_periods').length > 0" :label="$gettext('Payment Period')" label-for="user-payment-period">
                      <b-form-select id="user-payment-period" v-model="user.payment_period" :options="accountingCatalogs.filter(x => x.catalog === 'payment_periods').map(x => { return {text: x.name, value: x.id}})" class="form-control">
                        <template #first>
                          <option :value="null" v-translate>Select</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group class="col-lg-6" v-if="accountingCatalogs.filter(x => x.catalog === 'invoicing_programs').length > 0" :label="$gettext('Invoicing Program')" label-for="user-invoicing-program">
                      <b-form-select id="user-invoicing-program" v-model="user.invoicing_program" :options="accountingCatalogs.filter(x => x.catalog === 'invoicing_programs').map(x => { return {text: x.name, value: x.id}})" class="form-control">
                        <template #first>
                          <option :value="null" v-translate>Select</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                    <div class="form-group col-xl-6">
                      <label for="change-status" v-translate>Phone</label>
                      <div class="input-group">
                        <span class="form-control">{{user.phone | phone}}</span>
                        <b-button size="sm" v-if="user.phone" v-b-modal.modalChangePhone v-translate>Change Phone</b-button>
                        <b-button size="sm" v-else v-b-modal.modalChangePhone v-translate>Add Phone</b-button>

                        <b-modal id="modalChangePhone" ref="modalChangePhone" title="Change User Phone" @ok="changePhone" @shown="phone = null" @hide="phone = null">
                          <form @submit.stop.prevent="changePhone">
                            <input-phone id="phone" :phone-number="user.phone || ''" v-model="phone" :default-country-code="this.$cookies.get('country') ? this.$cookies.get('country') : 'AR'" />
                            <b-form-text v-translate>There won't be any validation so check twice what are you changing. International format, please</b-form-text>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="control-label" v-translate>Country</label>
                      <b-form-select v-model="user.country_iso_code" :options="countriesSelect" class="mb-3" required :disabled="!!user.company || bypassCountryCheck">
                        <template slot="first">
                          <option :value="null" v-translate>Select a country</option>
                        </template>
                      </b-form-select>
                    </div>
                    <b-col cols="12" class="mb-4">
                      <h5 v-translate>Alternative Contacts</h5>
                      <b-row>
                        <dl v-for="(contact, index) in user.alternative_contacts" :key="index" class="col-lg-6">
                          <dt>{{contact.reference}}</dt>
                          <dd>
                            <font-awesome-icon :icon="contact.type === 'email' ? 'envelope' : 'phone'" />
                            {{contact.value}}
                            <font-awesome-icon class="text-primary" icon="edit" @click="editAlternativeContactIndex = index; editAlternativeContact = contact" v-b-modal.modalEditAlternativeContact />
                            <font-awesome-icon class="text-danger" icon="trash-alt" @click="deleteAlternativeContact(index)" />
                          </dd>
                        </dl>
                        <b-modal id="modalEditAlternativeContact" ref="modalEditAlternativeContact" title="Edit Alternative Contact" @ok="updateAlternativeContact" @hide="editAlternativeContactIndex = null; editAlternativeContact = {}">
                          <form @submit.stop.prevent="updateAlternativeContact">
                            <b-form-group :label="$gettext('Reference')" label-for="alt-contact-reference">
                              <b-form-input id="alt-contact-reference" type="text" v-model="editAlternativeContact.reference" />
                            </b-form-group>
                            <b-form-group :label="$gettext('Type')" label-for="alt-contact-type">
                              <b-form-select id="alt-contact-type" type="text" v-model="editAlternativeContact.type" :options="[{value: 'phone', text: $gettext('Phone')}, {value: 'email', text: $gettext('Email')}]" />
                            </b-form-group>
                            <b-form-group :label="$gettext('Value')" label-for="alt-contact-value">
                              <b-form-input id="alt-contact-value" type="text" v-model="editAlternativeContact.value" />
                            </b-form-group>
                          </form>
                        </b-modal>
                      </b-row>
                      <b-button size="sm" v-b-modal.modalAddAlternativeContact v-translate>Add Alternative Contact</b-button>
                      <b-modal id="modalAddAlternativeContact" ref="modalAddAlternativeContact" :title="$gettext('New Alternative Contact')" @ok="addAlternativeContact" @hide="newAltContact = {reference: '', type: 'phone', value: ''}">
                        <form @submit.stop.prevent="addAlternativeContact">
                          <b-form-group :label="$gettext('Reference')" label-for="alt-contact-reference">
                            <b-form-input id="alt-contact-reference" type="text" v-model="newAltContact.reference" />
                          </b-form-group>
                          <b-form-group :label="$gettext('Type')" label-for="alt-contact-type">
                            <b-form-select id="alt-contact-type" type="text" v-model="newAltContact.type" :options="[{value: 'phone', text: $gettext('Phone')}, {value: 'email', text: $gettext('Email')}]" />
                          </b-form-group>
                          <b-form-group :label="$gettext('Value')" label-for="alt-contact-value">
                            <b-form-input id="alt-contact-value" type="text" v-model="newAltContact.value" />
                          </b-form-group>
                        </form>
                      </b-modal>
                    </b-col>
                    <div class="form-group col-lg-6 col-lg-8" v-if="user.profile_address !== null">
                      <label for="from_extra" v-translate>Street and number</label>
                      <div class="input-group">
                        <textarea class="form-control" type="text" :value="user.profile_address.place.formatted_address" disabled>{{user.profile_address.place.formatted_address}}</textarea>
                      </div>
                    </div>
                    <div class="form-group col-md-6 col-lg-4" v-if="user.profile_address !== null">
                      <label for="address_extra" v-translate>Floor, door, etc.</label>
                      <div class="input-group">
                        <b-form-input id="address_extra" name="address_extra" :value="user.profile_address.address_extra" class="" disabled />
                      </div>
                    </div>

                    <div class="form-group col-12">
                      <br>
                      <b-form-checkbox
                        id="user-notif"
                        name="user-notif"
                        v-model="user.send_notifications"
                        :value="1"
                        :unchecked-value="0"
                      >
                        <translate>Send Notifications</translate>
                      </b-form-checkbox>
                    </div>
                    <div class="form-group col-xl-5">
                      <label for="change-status" v-show="!user.company" v-translate>Company</label>
                      <label for="change-status" v-show="user.company" v-translate>Change Company</label>
                      <div class="input-group">
                        <company-autocomplete ref="companyAc" @selected="onSearchCompanySelected" class="w-100" />
                        <p v-show="this.selectedCompany" class="bg-warning" v-translate="{id: user.company_id}">Selected company: #%{id} (please submit changes)</p>
                      </div>
                    </div>
                    <div v-if="user.company" class="col-xl-7">
                      <br>
                      <translate>or</translate>
                      <b-button variant="danger" size="sm" @click.prevent="deleteCompany()" v-translate="{name: user.company.name}">Delete user from %{name} company</b-button>
                    </div>
                    <div v-if="user.company">

                      <br>
                      <p><img v-if="user.company.logo" :src="user.company.logo" alt="" style="width:auto; max-width: 200px; height: auto; max-height: 50px;"><br>
                        <translate>Company ID:</translate>
                        <a :href="'/edit/companies/' + user.company.id" target="_blank">#{{user.company.id }}</a><br>
                        <span v-translate="{data: user.company.name}">Company Name: %{data}</span>
                      </p>
                    </div>
                    <hr>
                    <div class="form-group col-12 form-actions">
                      <b-button variant="secondary" size="lg" @click.prevent="updateUser()" v-translate>Save Changes</b-button>
                    </div>
                  </b-form-row>
                </b-form>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col>
          <div class="text-center mb-3">
            <b-button size="sm" variant="dark" v-b-modal.modalUserLog @click="fetchUserLog(1)" v-translate>Changes Log</b-button>
            <b-modal id="modalUserLog" ref="modalUserLog" size="lg" hide-footer @hidden="userLog = {}">
              <div slot="modal-title" v-translate>User Changes Log</div>
              <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
              <log-list :log="userLog" @page-changed="fetchUserLog($event)" />
            </b-modal>
          </div>

          <comments-box-single-field comment-field-name="comment" :payload-field="this.user.meta || {}" payload-field-name="meta" :endpoint="this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id" @success="getUser" @delete="getUser" />

          <b-card class="role-permissions">
            <b-row>
              <b-col>
                <h2 v-translate>User Roles <small>(realtime change)</small></h2>
                <div v-for="role in rolesSelect" :key="role.value">
                  <b-form-checkbox
                    v-model="rolesSelected"
                    :key="role.value"
                    :value="role.value"
                    class="cols-12"
                    @change="changeRole(role.value)"
                    :disabled="role.disabled"
                  >
                  {{ role.text }}
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </b-card>

          <b-card class="user-tags" v-if="userIsCourier && user.courier_available && user.courier_available.carrying_cash_amount">
            <h2 v-translate>Cash On Delivery</h2>
            <dl>
              <dt v-translate>Currently Carrying</dt>
              <dd>{{user.courier_available.carrying_cash_amount | currency(user.country_iso_code)}}/{{user.country.cod_max_carrying_cash | currency(user.country_iso_code)}}</dd>
              <dt v-translate>Last COD Transaction Date</dt>
              <dd>{{moment.utc(user.courier_available.last_cod_transaction_date).format('L')}}</dd>
            </dl>
          </b-card>
          <b-card v-if="user.courier_available && userIsCourier && isAccountant">
            <h3 v-translate>Skips Cash Control?</h3>
            <b-form-group>
              <b-form-radio-group
                v-model="user.courier_available.skips_cash_control"
                :options="[{text: $gettext('YES'), value: 1}, {text: $gettext('NO'), value: 0}]"
                buttons
                button-variant="outline-secondary"
                size="lg"
                @input="updateSkipsCashControl"
              ></b-form-radio-group>
            </b-form-group>
          </b-card>

          <b-card class="courier-documentation" v-if="userIsCourier">
            <h2 v-translate>Courier Documentation</h2>
            <b-row>
              <b-col>
                <b-form-group>
                  <label for="card-id-number" v-translate>Document Number</label>
                  <div class="input-group">
                    <b-form-input v-model="user.card_id_number" type="text" />
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label for="drivers-license-expiration" v-translate>Driver's License Exp. Date</label>
                  <div class="input-group">
                    <b-form-input v-model="user.drivers_license_expiration" type="date" />
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label for="accepted-terms" v-translate>Accepted Courier Terms of Use</label>
                  <div class="input-group">
                    <b-form-input v-model="user.accepted_terms" type="text" />
                  </div>
                  <div :class="(!user.company_id && this.countries.find(x => x.iso_code === user.country_iso_code).individual_terms !== user.accepted_terms) || (user.company_id && this.countries.find(x => x.iso_code === user.country_iso_code).companies_terms !== user.accepted_terms) ? 'text-danger' :  ''"
                    v-translate="{data: !user.company_id ? this.countries.find(x => x.iso_code === user.country_iso_code).individual_terms : this.countries.find(x => x.iso_code === user.country_iso_code).companies_terms}">
                    Current Terms: %{data}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="mb-3 text-center">
                <h5 v-translate>Document Front</h5>
                <div v-show="user.card_id_front_picture">
                  <b-img v-if="user.card_id_front_picture" rounded="rounded" :src="user.card_id_front_picture" style="width: auto; height: auto; max-width: 100px; max-height: 100px;" blank-color="#777" alt="img" class="m-1" /><br>
                  <b-button pill size="sm" v-b-modal.modalUploadDocumentImage @click.prevent="uploadingField = 'card_id_front_picture'">
                    <translate>Change</translate>
                  </b-button>
                  <b-button pill size="sm" variant="danger" @click.stop="deleteDocumentImage('card_id_front_picture')" style="padding: .5rem .65rem">
                    <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
                  </b-button>
                </div>
                <div v-show="!user.card_id_front_picture">
                  <b-button size="sm" v-b-modal.modalUploadDocumentImage @click.prevent="uploadingField = 'card_id_front_picture'" v-translate>Document Front Photo</b-button>
                </div>
              </b-col>
              <b-col cols="6" class="mb-3 text-center">
                <h5 v-translate>Document Back</h5>
                <div v-show="user.card_id_back_picture">
                  <b-img v-if="user.card_id_back_picture" rounded="rounded" :src="user.card_id_back_picture" style="width: auto; height: auto; max-width: 100px; max-height: 100px;" blank-color="#777" alt="img" class="m-1" /><br>
                  <b-button pill size="sm" v-b-modal.modalUploadDocumentImage @click.prevent="uploadingField = 'card_id_back_picture'">
                    <translate>Change</translate>
                  </b-button>
                  <b-button pill size="sm" variant="danger" @click.stop="deleteDocumentImage('card_id_back_picture')" style="padding: .5rem .65rem">
                    <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
                  </b-button>
                </div>
                <div v-show="!user.card_id_back_picture">
                  <b-button size="sm" v-b-modal.modalUploadDocumentImage @click.prevent="uploadingField = 'card_id_back_picture'" v-translate>Document Back Photo</b-button>
                </div>
              </b-col>
              <b-col cols="6" class="mb-3 text-center">
                <h5 v-translate>Driver's License Front</h5>
                <div v-show="user.drivers_license_front_picture">
                  <b-img v-if="user.drivers_license_front_picture" rounded="rounded" :src="user.drivers_license_front_picture" style="width: auto; height: auto; max-width: 100px; max-height: 100px;" blank-color="#777" alt="img" class="m-1" /><br>
                  <b-button pill size="sm" v-b-modal.modalUploadDocumentImage @click.prevent="uploadingField = 'drivers_license_front_picture'">
                    <translate>Change</translate>
                  </b-button>
                  <b-button pill size="sm" variant="danger" @click.stop="deleteDocumentImage('drivers_license_front_picture')" style="padding: .5rem .65rem">
                    <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
                  </b-button>
                </div>
                <div v-show="!user.drivers_license_front_picture">
                  <b-button size="sm" v-b-modal.modalUploadDocumentImage @click.prevent="uploadingField = 'drivers_license_front_picture'" v-translate>Driver's License Front Photo</b-button>
                </div>
              </b-col>
              <b-col cols="6" class="mb-3 text-center">
                <h5 v-translate>Driver's License Back</h5>
                <div v-show="user.drivers_license_back_picture">
                  <b-img v-if="user.drivers_license_back_picture" rounded="rounded" :src="user.drivers_license_back_picture" style="width: auto; height: auto; max-width: 100px; max-height: 100px;" blank-color="#777" alt="img" class="m-1" /><br>
                  <b-button pill size="sm" v-b-modal.modalUploadDocumentImage @click.prevent="uploadingField = 'drivers_license_back_picture'">
                    <translate>Change</translate>
                  </b-button>
                  <b-button pill size="sm" variant="danger" @click.stop="deleteDocumentImage('drivers_license_back_picture')" style="padding: .5rem .65rem">
                    <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
                  </b-button>
                </div>
                <div v-show="!user.drivers_license_back_picture">
                  <b-button size="sm" v-b-modal.modalUploadDocumentImage @click.prevent="uploadingField = 'drivers_license_back_picture'" v-translate>Driver's License Back Photo</b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>

          <b-card class="user-tags" v-if="userIsCourier">
            <h2 v-translate>Tags</h2>
            <div>
              <vue-tags-input
                v-model="tag"
                :tags="tags"
                :autocomplete-items="autocompleteItems"
                @tags-changed="getUser"
                @before-adding-tag="checkTag"
                @before-deleting-tag="deleteTag"
                :disabled="!isSuperAdmin && !isOperatorSupervisor"
                :placeholder="$gettext('Add Tag')"
              />
            </div>
          </b-card>

          <b-card class="user-vehicles" v-if="userIsCourier">
            <h2 v-translate>Vehicles</h2>
            <b-table striped :items="user.vehicles" :fields="vehicleFields" v-if="user.vehicles.length > 0">
              <template v-slot:cell(vehicle_type)="data">
                {{ vehicleTypes.find(x => x.id === data.item.vehicle_type_id).name}}
              </template>
              <template v-slot:cell(vehicle_card_picture)="data">
                <a :href="data.value" target="_blank" v-if="data.value" v-translate>YES</a>
                <span v-else v-translate>NO</span>
              </template>
              <template v-slot:cell(insurance_card_picture)="data">
                <a :href="data.value" target="_blank" v-if="data.value" v-translate>YES</a>
                <span v-else v-translate>NO</span>
              </template>
              <template v-slot:cell(actions)="data">
                <b-button pill size="sm" variant="danger" @click.stop="deleteVehicle(data.item)" style="padding: .5rem .65rem">
                  <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
                </b-button>
                <b-button pill size="sm" @click.stop="editingVehicle = data.item" v-b-modal.modalEditVehicle style="padding: .5rem .55rem">
                  <font-awesome-icon :icon="['fa', 'pencil-alt']" size="2x" style="font-size: 16px;vertical-align: middle" />
                </b-button>
              </template>
            </b-table>
            <b-button v-b-modal.modalAddVehicle v-translate>Add Vehicle</b-button>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="moover-shippings" v-if="user.vehicles.length > 0">
            <api-list type="shippings" :title="$gettext('Shippings (as moover)')" :fields="shippingsFields" :prePerPage="10" :preFilters="[['courier_id', 'eq', user.id]]" />
          </b-card>
          <b-card class="user-shippings">
            <api-list type="shippings" :title="$gettext('Shippings (as user)')" :fields="shippingsFields" :prePerPage="10" :preFilters="[['user_id', 'eq', user.id]]" />
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-modal id="modalChangePassword" ref="modalChangePassword" :hide-footer="true" @hidden="newPassword = ''; passwordConfirm = ''; newPasswordScore = 0;">
      <div slot="modal-title" v-translate>Force Change User's Password</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <form @submit.prevent="changePassword">
        <b-form-row>
          <div class="form-group col-12">
            <label class="control-label" v-translate>New Password</label>
            <password ref="pwd_check" :min="passwordMinLength" :placeholder="$gettext('New Password')" v-model="newPassword" inputClass="form-control" @input="validatePassword" @score="newPasswordScore = $event" :min-score="passwordMinScore" />
            <b-form-text id="inputLiveHelp" v-translate="{minLength: passwordMinLength}">%{minLength} characters minimum, must contain upper and lower case letters, numbers and symbols</b-form-text>
          </div>
          <div class="form-group col-12">
            <label class="control-label" v-translate>Repeat New Password</label>
            <b-form-input aria-describedby="inputLiveHelp inputLiveFeedback" :placeholder="$gettext('Repeat New Password')" :state="samePassword" type="password" v-model="passwordConfirm" @input="validatePassword" autocomplete="new-password" required></b-form-input>
            <b-form-invalid-feedback id="inputLiveFeedback" v-translate>Passwords don't match</b-form-invalid-feedback>
          </div>
        </b-form-row>
        <b-form-row>
          <div class="text-center form-group col-12 form-actions">
            <b-button type="submit" variant="secondary" :disabled="!samePassword || newPassword.length < passwordMinLength || newPasswordScore < passwordMinScore" size="lg" v-translate>Change</b-button>
            <b-button type="button" @click.prevent="resetChangePassword" variant="outline-secondary" size="lg" v-translate>Cancel</b-button>
          </div>
        </b-form-row>
      </form>
    </b-modal>
    <b-modal id="modalUploadImage" ref="modalUploadImage" :hide-footer="true">
      <div slot="modal-title" v-translate>Add a new profile image</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <profile-picture-uploader profilePicture @updateProfileImage="updateProfileImage" />
    </b-modal>

    <b-modal id="modalUploadDocumentImage" ref="modalUploadDocumentImage" :hide-footer="true">
      <div slot="modal-title" v-translate>Add a new document image</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <profile-picture-uploader @updateProfileImage="updateDocumentImage" />
    </b-modal>

    <b-modal id="modalAddVehicle" ref="modalAddVehicle" :hide-footer="true">
      <div slot="modal-title" v-translate>Add new vehicle to user</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <vehicle-form :user="user" @success="$refs.modalAddVehicle.hide(); getUser();" @cancel="$refs.modalAddVehicle.hide();" />
    </b-modal>

    <b-modal id="modalEditVehicle" ref="modalEditVehicle" :hide-footer="true">
      <div slot="modal-title" v-translate>Edit vehicle</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <vehicle-form :user="user" :vehicle="editingVehicle" @success="editingVehicle = null; $refs.modalEditVehicle.hide(); getUser();" @cancel="editingVehicle = null; $refs.modalEditVehicle.hide();" />
    </b-modal>
  </b-container>
</template>

<script>
import ApiList from '@/components/ApiList'
import Cleave from 'vue-cleave'
import StarRating from 'vue-star-rating'
import ProfilePictureUploader from '@/components/ProfilePictureUploader'
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import Password from '@/components/Password'
import FixedPriceForm from '@/components/FixedPriceForm'
import PendingFixedPrices from '@/components/PendingFixedPrices'
import VueTagsInput from '@johmun/vue-tags-input'
import VehicleForm from '@/components/VehicleForm'
import InputPhone from '@/components/InputPhone'
import LogList from '@/components/LogList'
import CommentsBoxSingleField from '@/components/CommentsBoxSingleField'

export default {
  components: {
    ApiList,
    Cleave,
    StarRating,
    ProfilePictureUploader,
    CompanyAutocomplete,
    Password,
    FixedPriceForm,
    PendingFixedPrices,
    VueTagsInput,
    VehicleForm,
    InputPhone,
    LogList,
    CommentsBoxSingleField
    // AdminShipping
  },
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      searchQuery: '',
      selectedSearchItem: null,
      selectedCompany: null,
      acOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name, Business Name or TIN'),
        inputClass: 'form-control'
      },
      minCharacter: 2,
      user: null,
      userStatuses: [
        'pending',
        'confirmed',
        'suspended'
      ],
      vehicleFields: [
        {
          key: 'reference',
          label: this.$gettext('Reference')
        },
        {
          key: 'plate_number',
          label: this.$gettext('Plate Number')
        },
        {
          key: 'vehicle_type',
          label: this.$gettext('Type')
        },
        {
          key: 'insurance_expiration_date',
          label: this.$gettext('Insurance Exp.')
        },
        {
          key: 'vehicle_card_picture',
          label: this.$gettext('Vehicle Card')
        },
        {
          key: 'insurance_card_picture',
          label: this.$gettext('Insurance Card')
        },
        {
          key: 'actions',
          label: this.$gettext('Actions')
        }
      ],
      rolesSelected: [],
      userMobileApps: [],
      mobileApps: [],
      shippings: [],
      shippingsFields: [
        'id',
        {
          key: 'status',
          label: this.$gettext('Status')
        },
        {
          key: 'from',
          formatter: (value, key, item) => {
            return item.address_from.formatted_address
          },
          label: this.$gettext('From')
        },
        {
          key: 'to',
          formatter: (value, key, item) => {
            return item.address_to.formatted_address
          },
          label: this.$gettext('To')
        },
        {
          key: 'created_at',
          label: this.$gettext('Created At')
        },
        {
          key: 'updated_at',
          label: this.$gettext('Updated At')
        }
      ],
      newPassword: '',
      passwordConfirm: '',
      samePassword: null,
      passwordMinLength: 12,
      passwordMinScore: 100,
      newPasswordScore: 0,
      phone: null,
      tag: '',
      tags: [],
      autocompleteItems: [],
      debounce: null,
      uploadingField: null,
      editingVehicle: null,
      accountingCatalogs: [],
      newAltContact: {
        reference: '',
        type: 'phone',
        value: ''
      },
      editAlternativeContactIndex: null,
      editAlternativeContact: {},
      hasTin: false,
      disableReasonId: null,
      userLog: {},
      newComment: null
    }
  },
  computed: {
    userIsSuperAdmin() {
      return this.user.roles.findIndex(x => x.name === 'super-admin') !== -1
    },
    userIsCourier() {
      return this.user.roles.findIndex(x => x.name === 'courier') !== -1
    },
    bypassCountryCheck() {
      return this.isSuperAdmin ? false : window.countries.find(x => x.iso_code === this.user.country_iso_code).front_config.bypassCountryCheck
    }
  },
  watch: {
    tag: 'initTagItems'
  },
  created() {
    this.fetchVehicleTypes()
    this.fetchCountries()
    this.fetchRoles(true)
    this.fetchDisableReasons()
  },
  mounted() {
    this.getUser()
  },
  methods: {
    getUser() {
      let params = {
        includes: [
          'disable_reason',
          'courier_available.tracking',
          'mobile_apps',
          'fixed_amounts.fixed_tour',
          'tags',
          'courier_available',
          'country'
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id, {params: params})
        .then(response => {
          this.selectedSearchItem = response.body
          this.user = response.body
          this.rolesSelected = this.user.roles.map((role) => {
            return role.id
          })
          this.pendingFixedPrices = response.body.fixed_amounts.filter(x => x.status === 'pending')

          if (this.user.active === 0 && this.user.courier_available) {
            this.$http.delete(this.$appConfig.api.baseUrl + 'couriers-available/' + this.user.courier_available.id)
          }

          this.$http.get(this.$appConfig.api.baseUrl + 'mobile-apps')
            .then(response => {
              this.mobileApps = response.body.data
              this.userMobileApps = this.user.mobile_apps.map(app => {
                return {
                  name: this.mobileApps.find(x => x.id === app.mobile_app_id).name,
                  version: app.version
                }
              })
            })

          this.tags = this.user.tags.map(x => {
            x.text = x.name
            return x
          })

          this.hasTin = !!this.user.tin

          this.fetchCourierShippings()
          this.fetchAccountingStuff()
        })
    },
    initTagItems() {
      if (this.tag.length < 2) return
      let params = {
        filter_groups: [
          {
            filters: [
              ['name', 'ct', this.tag]
            ]
          }
        ]
      }

      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.$http.get(this.$appConfig.api.baseUrl + 'tags', {params: params})
          .then(response => {
            this.autocompleteItems = response.body.data.map(x => {
              x.text = x.name
              return x
            })
          }).catch(() => console.warn('Oh. Something went wrong'))
      }, 600)
    },
    checkTag(obj) {
      if (!obj.tag.id) {
        this.$http.post(this.$appConfig.api.baseUrl + 'tags', {name: obj.tag.text.toLowerCase()})
          .then(response => {
            obj.tag.id = response.body.id
            obj.tag.text = response.body.name
            this.$http.post(this.$appConfig.api.baseUrl + 'tags-models', {tag_id: response.body.id, model_type: 'user', model_id: this.user.id + ''})
              .then(response => {
                obj.addTag()
              })
          })
      } else {
        this.$http.post(this.$appConfig.api.baseUrl + 'tags-models', {tag_id: obj.tag.id, model_type: 'user', model_id: this.user.id + ''})
          .then(response => {
            obj.addTag()
          })
      }
    },
    deleteTag(obj) {
      this.$http.delete(this.$appConfig.api.baseUrl + 'tags-models/' + obj.tag.tag_model_id)
        .then(response => {
          obj.deleteTag()
        })
    },
    updateProfileImage(url) {
      this.user.profile_picture = url
      this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id, { profile_picture: url }).then(response => {
        this.$refs.modalUploadImage.hide()
        this.showAlert()
      }, error => {
        let obj = {
          title: this.$gettext('ERROR'),
          message: error.body.message,
          type: 'error'
        }
        this.$parent.$refs.simplert.openSimplert(obj)
      })
    },
    deleteProfileImage() {
      if (confirm(this.$gettext('Are you sure you want to DELETE the user profile picture?'))) {
        this.user.profile_picture = null
        this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.user.id, { profile_picture: null })
          .then(response => {
            this.showAlert()
          }, error => {
            let obj = {
              title: this.$gettext('ERROR'),
              message: error.body.message,
              type: 'error'
            }
            this.$parent.$refs.simplert.openSimplert(obj)
          })
      }
    },
    updateDocumentImage(url) {
      this.user[this.uploadingField] = url
      this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id, { [this.uploadingField]: url }).then(response => {
        this.$refs.modalUploadDocumentImage.hide()
        this.uploadingField = null
        this.showAlert()
      }, error => {
        let obj = {
          title: this.$gettext('ERROR'),
          message: error.body.message,
          type: 'error'
        }
        this.$parent.$refs.simplert.openSimplert(obj)
      })
    },
    deleteDocumentImage(documentField) {
      if (confirm(this.$gettext('Are you sure you want to DELETE this document picture?'))) {
        this.user[documentField] = null
        this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.user.id, { [documentField]: null })
          .then(response => {
            this.showAlert()
          }, error => {
            let obj = {
              title: this.$gettext('ERROR'),
              message: error.body.message,
              type: 'error'
            }
            this.$parent.$refs.simplert.openSimplert(obj)
          })
      }
    },
    updateUser() {
      delete this.user.country
      delete this.user.phone
      delete this.user.roles
      delete this.user.vehicles
      if (!this.user.company_id) {
        delete this.user.company_id
      }
      this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id, this.user).then(response => {
        this.showAlert()
        this.getUser()
        this.selectedCompany = null
      })
    },
    updateSkipsCashControl() {
      this.$http.patch(this.$appConfig.api.baseUrl + 'couriers-available/' + this.user.courier_available.id, this.user.courier_available).then(response => {
        this.showAlert()
        this.getUser()
        this.selectedCompany = null
      })
    },
    validatePassword () {
      this.samePassword = this.newPassword.length > 0 ? this.newPassword === this.passwordConfirm : null
    },
    changePassword() {
      this.$http.put(this.$appConfig.api.baseUrl + 'users/change-password', { user_id: this.user.id, password: this.newPassword })
        .then(response => {
          this.showAlert()
          this.getUser()
          this.resetChangePassword()
        })
    },
    resetChangePassword() {
      this.newPassword = ''
      this.passwordConfirm = ''
      this.$refs.modalChangePassword.hide()
    },
    changePhone() {
      if (this.phone) {
        this.$http.patch(this.$appConfig.api.baseUrl + 'users/change-phone', { user_id: this.user.id, phone: this.phone ? this.phone.replace(/[^0-9+]+/g, '') : null })
          .then(response => {
            this.user.phone = this.phone
            this.showAlert()
            this.getUser()
            this.$refs.modalChangePhone.hide()
          })
      }
    },
    enableUser() {
      this.$http.post(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id + '/enable')
        .then(response => {
          this.showAlert()
          this.getUser()
        })
    },
    disableUser() {
      if (
        confirm(this.$gettext('Are you sure you want to DISABLE the User?'))
      ) {
        this.$http.delete(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id + '/disable/reason/' + this.disableReasonId)
          .then(response => {
            this.showAlert()
            this.getUser()
            this.$refs.modalDisableReason.hide()
          })
      }
    },
    deleteCompany() {
      if (confirm(this.$gettext('Are you sure you want to DELETE user from company?'))) {
        this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id, {company_id: null}).then(response => {
        // this.$store.dispatch(UPDATE_USER, this.user).then(response => {
          this.showAlert()
          this.getUser()
        }, error => {
          let obj = {
            title: this.$gettext('ERROR'),
            message: error.body.message,
            type: 'error'
          }
          this.$parent.$refs.simplert.openSimplert(obj)
        })
      } else {
        return false
      }
    },
    deleteVehicle(vehicle) {
      if (
        confirm(this.$gettextInterpolate(this.$gettext('Are you sure you want to DELETE the vehicle with Reference:\n%{reference}\nWARNING: THIS ACTION CANNOT BE UNDONE!'), {reference: vehicle.reference}))
      ) {
        this.$http.delete(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id + '/vehicles' + '/' + vehicle.id)
          .then(response => {
            this.getUser()
          })
      }
    },
    changeRole(role) {
      this.$nextTick(() => {
        if (this.rolesSelected.indexOf(role) !== -1) {
          this.$http.post(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id + '/roles', [role])
            .then(response => {
              console.log('ON')
              console.log(response)
              this.showAlert(this.$gettext('Role has been selected!'))
              this.getUser()
            })
        } else {
          this.$http.delete(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id + '/roles', {body: [role]})
            .then(response => {
              console.log('OFF')
              console.log(response)
              this.showAlert(this.$gettext('Role has been set OFF!'))
              this.getUser()
            })
        }
        console.log(role)
      })
    },
    fetchCourierShippings() {
      let params = {
        'page': 0,
        'limit': 1,
        'sort': [
          {'key': 'updated_at', 'direction': 'desc'}
        ],
        'filter_groups': [{
          'filters': [
            ['courier_id', 'eq', this.user.id]
          ]
        }]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          this.shippings = response.body
        }).catch(response => {

        })
    },
    reloadUser() {
      this.getUser()
    },
    onSearchCompanySelected(item) {
      this.user.company_id = item.id
      this.selectedCompany = item.id
    },
    resetAddVehicleFields() {
      this.$refs.modalAddVehicle.hide()
      Object.assign(this.$data.newVehicle, this.$options.data.call(this).newVehicle)
    },
    fixedPriceSuccess() {
      this.getUser()
      this.$refs.modalFixedPrice.hide()
    },
    fixedPriceCancel() {
      this.$refs.modalFixedPrice.hide()
    },
    fetchAccountingStuff() {
      let params = {
        sort: [{
          key: 'name',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['country_iso_code', 'eq', this.user.country_iso_code],
              ['catalog', 'in', ['document_types', 'tax_conditions', 'payment_periods', 'invoicing_programs']]
            ]
          }
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'accounting-catalogs', {params: params})
        .then(response => {
          this.accountingCatalogs = response.body.data
        })
    },
    addAlternativeContact() {
      if (!Array.isArray(this.user.alternative_contacts)) {
        this.user.alternative_contacts = []
      }
      this.user.alternative_contacts.push(this.newAltContact)
      this.updateAlternativeContacts()
    },
    updateAlternativeContact() {
      this.user.alternative_contacts[this.editAlternativeContactIndex] = this.editAlternativeContact
      this.updateAlternativeContacts()
    },
    deleteAlternativeContact(index) {
      if (confirm(this.$gettext('Are you sure you want to DELETE this user alternative contact?'))) {
        this.user.alternative_contacts.splice(index, 1)
        this.updateAlternativeContacts()
      }
    },
    updateAlternativeContacts() {
      this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id, {alternative_contacts: this.user.alternative_contacts})
        .then(response => {
          this.showAlert()
          this.getUser()
        })
    },
    fetchUserLog(page = 1) {
      let params = {
        limit: 25,
        page: page
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$route.params.id + '/audit', {params})
        .then(response => {
          response.body.data = response.body.data.map(x => {
            const targetKeys = Object.keys(x).filter((x) => /target_/.test(x))
            let targets = []
            for (const key in x) {
              if (Object.hasOwnProperty.call(x, key) && targetKeys.indexOf(key) !== -1 && key.indexOf('_updatedId') === -1 && key.indexOf('_priorValues') === -1) {
                if (key === 'target_roles') {
                  targets.push(this.isJson({[key]: this.rolesSelect.find(y => y.value === x[key][0]).text}))
                } else {
                  targets.push(this.isJson({[key]: x[key]}))
                }
              }
            }
            x = {
              change: ('<strong>' + this.camelCaseToTitleCase(x.event) + '</strong>' + (targets.length > 0 ? targets : '')).replace(/<\/ul>,<ul>/g, '').replace(/target_/g, ''),
              applied_by: {
                name: x.src_user_name
              },
              created_at: x.created_at
            }
            return x
          })
          this.userLog = response.body
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
